import styled from 'styled-components'

export const Container = styled.div`
    position: absolute;
    top: 50vh;
    left: 50vw;
    transform: translate(-50%, -50%);
    background-color: #fff;
    border-radius: 1vw;
    z-index: 1;
    padding:1.8rem;
    width:40rem;
    font-family: 'Inter', sans-serif;
`

export const HeaderDiv = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`

export const HeaderText = styled.h2`
    font-size: 1.8rem;
    font-weight: 700;
    margin-top: 0;
    margin-bottom: 0;
`

export const CloseDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 2vw;
    cursor: pointer;
    width: 2.5vw;
    height: 2.5vw;

    :hover{
        background-color: #F4F4F4;
    }
`

export const CloseImg = styled.img`
    width: 0.8vw;
`

export const InputDiv = styled.div`
    display:flex;
    flex-direction: column;
    gap:.5rem;
    margin-top:1.5rem;
`

export const LabelCreate = styled.label`
    font-weight:600;
`

export const InputProfileName = styled.input`
    width: 100%;
    height: 5.3vh;
    background-color: #EBEBEB;
    border: 0;
    border-radius: 2vw;
    padding-left: 1vw;
    padding-right: 1vw;

    :focus {
        outline: 0;
    }
`
export const ButtonsDiv = styled.div`
    display: flex;
    position: relative;
    justify-content:end;
    margin-top: 1rem;
`

export const CreateButtonDiv = styled.div`
    display: flex;
    align-items: center;
    width: auto;
    height: 5.8vh;
    padding:1.5rem;
    background-color: #0090D3;
    color: #fff;
    border-radius: 3vw;
    cursor: pointer;

`

export const CreateButtonImage = styled.img`
    width: 1vw;
`

export const CreateButtonText = styled.p`
    font-family: 'Inter', sans-serif;
    font-size: 1vw;
    font-weight: 700;
    margin-left: 0.5rem;
    margin-right:0.2rem;
`

export const ErrorMessage = styled.p`
    font-size: .75rem;
    color:red;
    font-weight: 300;
`

export const TipText = styled.p`
    font-family: 'Inter', sans-serif;
    color:red;
    font-weight: 300;
    font-size: .8rem;
    margin-right: 1rem;
    margin-top: 1.5rem;
`